import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  return {
    contentBox: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      padding: `${pxToRem(18)} 0 ${pxToRem(18)} 0`,
      borderBottom: `${pxToRem(1)} solid #DDDEDE`,
      [theme.breakpoints.down('sm')]: {
        padding: `${pxToRem(16)} 0 ${pxToRem(16)} 0`,
      },
    },
    mobileOnly: {
      width: '100%',
      marginTop: pxToRem(10),
      [theme.breakpoints.up('lg')]: {
        display: 'none',
      },
    },
    innerContent: {
      display: 'flex',
      alignItems: 'center',
      '& .dateHeading': {
        [theme.breakpoints.up('md')]: {
          width: theme.direction === 'rtl' ? pxToRem(240) : pxToRem(220),
        },
        fontSize: pxToRem(16),
        lineHeight: pxToRem(24),

        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(14),
          lineHeight: pxToRem(24),
        },
      },
      '& .sessionVenueTitle': {
        [theme.breakpoints.up('md')]: {
          width: pxToRem(150),
          textAlign: theme.direction === 'rtl' ? "left" : 'right',
        },
      },
      '& .contentText': {
        fontWeight: '400',
        fontSize: pxToRem(14),
        lineHeight: pxToRem(16),

        [theme.breakpoints.down('md')]: {
          fontSize: pxToRem(12),
          lineHeight: pxToRem(16),
        },
      }
    }
  };
});

export default useStyles;
